import { render, staticRenderFns } from "./informacion_pincipal.vue?vue&type=template&id=5e512f20"
import script from "./informacion_pincipal.vue?vue&type=script&lang=js"
export * from "./informacion_pincipal.vue?vue&type=script&lang=js"
import style0 from "./informacion_pincipal.vue?vue&type=style&index=0&id=5e512f20&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports